import React from 'react';
import {Button, Dropdown, Flex, Space} from 'antd';
import {connect, useDispatch, useSelector} from 'react-redux';
import {signOut, signOutSuccess} from 'redux/actions/Auth';
import Avatar from "../util-components/Avatar";

export const NavProfile = () => {
    const user = useSelector((state) =>state.auth.user_info )

  const dispatch = useDispatch();
    const items = [
        {
            key: '1',
            label: (
                <div className="nav-profile-content">
                    <div className="d-flex align-items-center">
                        <Avatar user={user} />
                        <div className="pl-3">
                            <h4 className="mb-0 mt-0">{user?.email}</h4>
                            <span className="text-muted">{user?.email}</span>

                        </div>

                    </div>
                    <Flex vertical className="mt-3" >
                        <Button type="link" danger onClick={()=> dispatch(signOutSuccess())}>
                            Đăng xuất
                        </Button>

                    </Flex>
                </div>
            ),
        },
    ];
    return (
        <Dropdown
            menu={{
                items,
            }}
        >
            <a onClick={(e) => e.preventDefault()}>
                <Space>
                    <Avatar user={user} styles={{
                        marginTop: '15px',
                        fontSize: '18px',
                        width: '36px',
                        height: '36px',
                    }} />
                </Space>
            </a>
        </Dropdown>
    );
};

export default connect(null, { signOut })(NavProfile);
